import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  DialogHeader,
  DialogActions,
  MaterialUICore,
} from '@iclinic/design-system';
import { Form, FormikProvider, useFormik } from 'formik';

import {
  saveAddressData,
  updateCurrentSubscriptionStep,
  updateSubscriptionStepMapper,
} from '../../state/reducer';
import { getCurrentSubscriptionStep } from '../../state/selectors';
import { BillingInfo, StepTypes } from '../../state/types';
import AddressForm from './AddressForm';
import * as S from './ModalAddressForm.styles';
import { validationAddressForm } from './validation';
import { onlyNumbers } from 'shared/utils/formatters';

const { useMediaQuery, useTheme } = MaterialUICore;

const ModalAddress = () => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const currentStep = useSelector(getCurrentSubscriptionStep);
  const isOpen = currentStep === StepTypes.ADDRESS;

  const initialValues: BillingInfo = {
    person_type: 'pf',
    responsible: '',
    cpf_cnpj: '',
    billing_zip: '',
    billing_state: '',
    billing_city: '',
    billing_neighborhood: '',
    billing_address: '',
    billing_number: '',
    billing_address2: '',
    billing_birthdate: '',
    billing_country: 'BR',
  };

  const onSubmit = (values: BillingInfo) => {
    const cleanValues = {
      ...values,
      cpf_cnpj: onlyNumbers(values.cpf_cnpj),
      billing_number: values.billing_number
        ? Number(values.billing_number)
        : '',
    };
    dispatch(saveAddressData(cleanValues));
    dispatch(updateCurrentSubscriptionStep(StepTypes.PAYMENT));
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationAddressForm,
    onSubmit,
    enableReinitialize: true,
  });

  const handleCloseModal = () => {
    dispatch(updateSubscriptionStepMapper());
    dispatch(updateCurrentSubscriptionStep());
    formik.resetForm();
  };

  return (
    <FormikProvider value={formik}>
      <Form>
        <S.Dialog
          open={isOpen}
          maxWidth="xl"
          fullScreen={isMobile}
          disableEscapeKeyDown
        >
          <DialogHeader
            title="Dados de faturamento"
            onClose={handleCloseModal}
          />

          <S.DialogContent>
            <AddressForm />
            <DialogActions>
              <Button
                variant="contained"
                color="transparent"
                onClick={handleCloseModal}
              >
                Voltar
              </Button>

              <Button onClick={() => formik.handleSubmit()}>Próximo</Button>
            </DialogActions>
          </S.DialogContent>
        </S.Dialog>
      </Form>
    </FormikProvider>
  );
};

export default ModalAddress;
